import { useEffect, useCallback, FC } from 'react';
import cn from 'classnames';
import { createPortal } from 'react-dom';
import { useUnmount } from 'react-use';

import styles from './Modal.module.scss';

interface IModalProps {
  visible: boolean;
  modalBodyClassName?: string;
  onClose: () => void;
}

export const Modal: FC<IModalProps> = ({ visible, modalBodyClassName, children, onClose }) => {
  const body = document.querySelector('body');
  const resetStyles = useCallback(() => {
    body?.removeAttribute('overflow');
  }, [body]);

  useEffect(() => {
    if (visible) {
      body?.setAttribute('overflow', 'hidden');
    } else {
      resetStyles();
    }
  }, [body, resetStyles, visible]);

  useUnmount(() => {
    resetStyles();
  });

  if (!visible || !body) {
    return null;
  }

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    resetStyles();
  };

  return createPortal(
    <div className={cn(styles.Modal, { [styles.ModalIsActive]: visible })} id="modal">
      <div className={cn(styles.ModalBody, modalBodyClassName)}>
        {children}
        <button className={styles.CloseButton} onClick={handleClose} type="button" />
      </div>
      <div className={styles.ModalBackground} onClick={handleClose} />
    </div>,
    body,
  );
};
